import { render } from "./PlayView.vue?vue&type=template&id=5f8dc670&scoped=true"
import script from "./PlayView.vue?vue&type=script&lang=js"
export * from "./PlayView.vue?vue&type=script&lang=js"

import "./PlayView.vue?vue&type=style&index=0&id=5f8dc670&scoped=true&lang=css"

import exportComponent from "/home/tamikatsu/Web/undercover/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8dc670"]])

export default __exports__